import { ModelRow, StringUtil } from "@mcleod/core";
import { AutogenLayoutEdiShipMatchCrit } from "./autogen/AutogenLayoutEdiShipMatchCrit";
import { TableRow, TableRowCreationEvent, Textbox, TableRowDisplayEvent, LookupModelSearchEvent, DropdownSelectionEvent, DataSourceExecutionEvent } from "@mcleod/components";

export class EdiShipMatchCrit extends AutogenLayoutEdiShipMatchCrit {
    private _profileId: string;
    private _version: string;
    private _partnerId: string;

    override async onLoad() {
        // Add custom CSS to expand dropdown width for operator textboxes
        const style = document.createElement('style');
        style.textContent = `
            /* Expand dropdown width when triggered by textboxes with wide-dropdown-trigger class */
            .wide-dropdown-trigger ~ .ovr-popup,
            .wide-dropdown-trigger + .ovr-popup,
            body:has(.wide-dropdown-trigger:focus) .ovr-popup {
                min-width: 200px !important;
            }
            /* More specific targeting for dropdown item lists */
            body:has(.wide-dropdown-trigger:focus) .ovr-overlayContent {
                min-width: 200px !important;
            }
            /* Target all dropdown popups for now - you can make this more specific later */
            .ovr-popup {
                min-width: 150px !important;
            }
        `;
        document.head.appendChild(style);
    }


    /** This is an event handler for the onRowCreate event of tableShipMatchRule. */
    tableShipMatchRuleOnRowCreate(event: TableRowCreationEvent) {
        //do appending stuff here
        const tableRow = event.getTableRow() as TableRow;
        const modelRow = tableRow.data as ModelRow;

        if (modelRow._appending) {
            modelRow.set("criteria_id", this.sourceEdiShipmatchCrit.activeRow?.get("id"));
            modelRow.set("profile_id", this.sourceEdiShipmatchCrit.activeRow?.get("profile_id", this.profileId));
            modelRow.set("version", this.version);
            // Set initial sequence - this will be updated by onRowDisplay to the correct position
            const currentRowCount = this.tableShipMatchRule.allRows ? this.tableShipMatchRule.allRows.length : 0;
            modelRow.set("sequence", currentRowCount + 1);
        }
    }

    /** This is an event handler for the onRowDisplay event of tableShipMatchRule. */
    tableShipMatchRuleOnRowDisplay(event: TableRowDisplayEvent) {
        const tableRow = event.getTableRow() as TableRow;
        const modelRow = tableRow.data;

        if (tableRow) {
            // Set the sequence textbox to the row index (1-based)
            const sequenceTextbox = tableRow.findComponentById("textboxSequence") as Textbox;
            if (sequenceTextbox) {
                // Get the row index from the table
                const allRows = this.tableShipMatchRule.allRows;
                const rowIndex = allRows.indexOf(tableRow);
                if (rowIndex >= 0) {
                    sequenceTextbox.text = rowIndex + 1 + "";
                    tableRow.data.set("sequence", rowIndex + 1);
                }
            }

            // Customize the operator dropdown width by adding a CSS class
            const operatorTextbox = tableRow.findComponentById("textboxOperator") as Textbox;
            if (operatorTextbox) {
                operatorTextbox._element.classList.add('wide-dropdown-trigger');
            }

            const textboxStatusTableName = tableRow.findComponentById("textboxStatusTable") as Textbox;
            const textboxStatusField = tableRow.findComponentById("textboxStatusField") as Textbox;
            const textboxTablename = tableRow.findComponentById("textboxTablename") as Textbox;
            const textboxField = tableRow.findComponentById("textboxField") as Textbox;
            const textboxQualifier = tableRow.findComponentById("textboxQualifier") as Textbox;
            textboxStatusTableName.lookupModelDisabled = true;
            textboxTablename.lookupModelDisabled = true;

            textboxField.enabled = !StringUtil.isEmptyString(modelRow.getString("table_name", ""));
            textboxQualifier.visible = (modelRow.getString("table_name", "") === "reference_number");
        }
    }

    /** This is an event handler for the beforeLookupModelSearch event of textboxStatusField. */
    textboxStatusFieldBeforeLookupModelSearch(event: LookupModelSearchEvent) {
        event.filter.table_name = "edistatus";
    }

    /** This is an event handler for the beforeLookupModelSearch event of textboxField. */
    textboxFieldBeforeLookupModelSearch(event: LookupModelSearchEvent) {
        const textbox = event.target as Textbox;
        const tableRow = TableRow.getContainingTableRow(textbox);
        const modelRow: ModelRow = tableRow.data as ModelRow;

        event.filter.table_name = modelRow.getString("table_name", "");
    }

    /** This is an event handler for the afterDropdownSelection event of textboxTablename. */
    textboxTablenameAfterDropdownSelection(event: DropdownSelectionEvent) {
        const textbox = event.target as Textbox;
        const tableRow = TableRow.getContainingTableRow(textbox);
        const textQualifier = tableRow.findComponentById("textboxQualifier") as Textbox;
        const textboxField = tableRow.findComponentById("textboxField") as Textbox;

        const modelRow: ModelRow = tableRow.data as ModelRow;
        textQualifier.visible = (modelRow.getString("table_name", "") === "reference_number");
        textboxField.enabled = !StringUtil.isEmptyString(modelRow.getString("table_name", ""));

    }

    public get profileId(): string {
        return this._profileId;
    }
    public set profileId(value: string) {
        this._profileId = value;
    }

    /** This is an event handler for the beforeExecution event of sourceEdiShipmatchCrit. */
    sourceEdiShipmatchCritBeforeExecution(event: DataSourceExecutionEvent) {
        if (this.sourceEdiShipmatchCrit.activeRow._appending) {
            this.sourceEdiShipmatchCrit.activeRow.set("profile_id", this._profileId);
        }
    }

    public get version(): string {
        return this._version;
    }
    public set version(value: string) {
        this._version = value;
    }

    public get partnerId(): string {
        return this._partnerId;
    }
    public set partnerId(value: string) {
        this._partnerId = value;
    }

/** This is an event handler for the beforeLookupModelSearch event of textboxQualifier. */
  textboxQualifierBeforeLookupModelSearch(event: LookupModelSearchEvent) {
      event.filter.element_id = "128";
      event.filter.version = this.version;
      event.filter.partner_id = this.partnerId;
  }
}
